import Framework, { BaseService } from '@greenville/framework';
import { AET_STORE_EVENTS } from '../common/Constants';

export default class DifficultQuestionsService extends BaseService {
  constructor() {
    super(AET_STORE_EVENTS.DIFFICULT_QUESTIONS_REQUESTED, 'difficultQuestionsStatus');
  }

  // TODO:: remove this later
  handleEvent(eventName, eventData = {}) {
    const { courseId, assignmentId } = eventData;
    const marinClient = this.getClient('marin');
    return marinClient.get(`aet/courses/${courseId}/assignments/${assignmentId}/difficult-questions`);
  }

  // eslint-disable-next-line class-methods-use-this
  handleResponse(response, eventData = {}) {
    const { assignmentId } = eventData;
    const questions = response?.data?.items || [];

    Framework.getStoreRegistry().getStore('assignment').setDifficultQuestions(assignmentId, questions);
    Framework.getEventManager().publish(AET_STORE_EVENTS.DIFFICULT_QUESTIONS_COMPLETED, questions);
  }

  // eslint-disable-next-line class-methods-use-this
  handleError(error) {
    Framework.getEventManager().publish(AET_STORE_EVENTS.DIFFICULT_QUESTIONS_FAILED, error);
  }
}
